import http from "@/settings/apiSettings"

class PRO_ClaseDataService{
    save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/PRO_Clase", data);
    }
    getParents(): Promise<any> {
        return http.clientComercialOdata.get("/PRO_Clase/with-parent");
    }
  
}
export default new PRO_ClaseDataService();